import React, { useEffect, useState } from "react";
import { ListInput } from "@sonder/ui/source/styled/fragments/ListInput";
import { useSegment } from "analytics/segment";
import { useUpdateTask } from "core/queries/UpdateTask";

interface TaskDescriptionProps {
  className?: string;
  description: string;
  eventName: string;
  taskId: string;
  onChange?(nextDescription: string): void;
  onFocus?(e: React.FocusEvent<HTMLInputElement>): void;
}
export const TaskDescription = ({
  className,
  description: globalDescription,
  eventName,
  taskId,
  onChange = () => undefined,
  onFocus = () => undefined,
}: TaskDescriptionProps) => {
  const [onUpdateTask] = useUpdateTask({
    refetchQueries: ["GetTasks"],
  });

  const [description, setDescription] = useState(globalDescription);
  useEffect(() => {
    if (description !== globalDescription) setDescription(globalDescription);
  }, [globalDescription]);
  const { track } = useSegment();
  return (
    <ListInput
      className={className}
      name="task-description"
      placeholder="Enter task name..."
      value={description}
      onBlur={() => {
        const trimmedDescription = description.trim();
        if (Boolean(trimmedDescription) && description !== globalDescription) {
          onChange(trimmedDescription);
          onUpdateTask({
            variables: {
              taskId,
              description: trimmedDescription,
            },
          });
          setDescription(trimmedDescription);
          track({
            eventName,
            action: "edit",
            element: "description_input",
            props: { taskId },
          });
        } else setDescription(globalDescription);
      }}
      onChange={e => setDescription(e.target.value)}
      onFocus={onFocus}
    />
  );
};
